const DODO_RETURN_PARAM_KEYS = [
  'status',
  'payment_status',
  'payment_id',
  'subscription_id',
  'session_id',
  'transaction_id',
  'email',
  'license_key',
] as const;

export type DodoReturnStatus =
  | 'succeeded'
  | 'failed'
  | 'cancelled'
  | 'processing'
  | null;

export interface DodoReturnState {
  hasDodoParams: boolean;
  status: DodoReturnStatus;
  isFailure: boolean;
  cleanedSearch: string;
}

function normalizeDodoReturnStatus(rawStatus: string | null): DodoReturnStatus {
  if (!rawStatus) {
    return null;
  }

  switch (rawStatus.trim().toLowerCase()) {
    case 'success':
    case 'succeeded':
    case 'active':
      return 'succeeded';
    case 'failed':
    case 'failure':
      return 'failed';
    case 'cancelled':
    case 'canceled':
      return 'cancelled';
    case 'processing':
    case 'pending':
      return 'processing';
    default:
      return null;
  }
}

export function parseDodoReturn(search: string): DodoReturnState {
  const params = new URLSearchParams(search);
  const hasDodoParams = DODO_RETURN_PARAM_KEYS.some((key) => params.has(key));
  const status = normalizeDodoReturnStatus(
    params.get('status') || params.get('payment_status')
  );

  DODO_RETURN_PARAM_KEYS.forEach((key) => params.delete(key));
  const cleanedParams = params.toString();

  return {
    hasDodoParams,
    status,
    isFailure: status === 'failed' || status === 'cancelled',
    cleanedSearch: cleanedParams ? `?${cleanedParams}` : '',
  };
}
